import { customPalette } from "../../theme/theme";

import { JSX } from "react";

import { Box, CardMedia, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";

interface IPreselectionBtn {
  label: string;
  description?: string;
  cfgObjectId: string;
  imgSrc?: string;
}

export const PreselectorBtn = ({
  label,
  description,
  cfgObjectId,
  imgSrc,
}: IPreselectionBtn): JSX.Element => {
  const navigate = useNavigate();

  const handleNavigate = (): void => {
    navigate({
      to: "/configurator",
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        cfgObjectId,
      }),
    });
  };

  const handleClick = (): void => {
    handleNavigate();
  };

  return (
    <>
      <Box
        onClick={() => {
          handleClick();
        }}
        sx={{
          display: "flex",
          alignItems: "start",
          gap: 2,
          padding: 0,
          cursor: "pointer",
        }}
      >
        <Box sx={{ width: "15rem" }}>
          <CardMedia component="img" width="100%" image={imgSrc} alt={imgSrc} />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography
            textAlign="left"
            variant="h5"
            sx={{
              color: customPalette.primary.main,
            }}
          >
            {label}
          </Typography>
          <Typography
            variant="body1"
            textAlign="left"
            sx={{
              maxWidth: "11rem",
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
